import Application from './Application';
import common from './common';
import PreloaderScene from './scenes/PreloaderScene';

export default class Main {
    /**
     * @param {number} [width=1024]
     * @param {number} [height=768]
     */
    constructor(width = 1024, height = 768) {
        this._width = width;
        this._height = height;
        this._app = null;
        this._preloader = null;
    }

    init() {
        P3.assets.audioFileTypes = ['ogg', 'mp3'];
        P3.assets.signals.audioFile.add(P3.audio.addSound, P3.audio);
        P3.audio.preloadAudio = true;

        PIXI.settings.RETINA_PREFIX = /_(?=[^_]*$)(.+)x/;
        PIXI.settings.MIPMAP_TEXTURES = false;
        PIXI.settings.STRICT_TEXTURE_CACHE = true;

        typeof TweenMax !== 'undefined' && (TweenMax.defaultOverwrite = 'none');

        const options = {
            width: this._width,
            height: this._height,
            holderId: 'game',
            portrait: false,
            rotateImageUrl: './assets/images/rotate.jpg',
            rotateImageColor: '#000000',
            aspectRatioFillHeight: true
        };

        const view = new P3.View(options);
        view.signals.ready.once(function (canvas) {
            const options = {};
            options.view = canvas;
            options.transparent = true;
            options.antialias = false;
            options.preserveDrawingBuffer = false;
            options.resolution = 1;

            const stage = new PIXI.Container();
            common.stage = stage;

            P3.input.init(stage, canvas);

            if (P3.utils.isCocoonJS()) {
                stage.scale.x = window.innerHeight / options.height;
                stage.scale.y = window.innerHeight / options.height;
            }

            const renderer = PIXI.autoDetectRenderer(Object.assign(options, {
                width: this._width, height: this._height
            }));

            renderer.backgroundColor = 0x0;
            common.renderer = renderer;

            common.stage.addChild(P3.scene.view);

            const transitions = new PIXI.Container();
            common.stage.addChild(transitions);
            common.transitions = transitions;


            PIXI.Ticker.shared.add((deltaTime) => {
                window.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;

                // window.deltaTime = window.deltaTime;

                // deprecated
                //const currentTime = P3.utils.TWEEN.now();
                //window.tweendt = currentTime - window.lasttweentime;
                //window.lasttweentime = currentTime;

                P3.scene.update(window.deltaTime);
                P3.input.update();

                P3.utils.TWEEN.update();// comment this line out if you are using TweenMax

                renderer.render(stage);
            });

            this.loadPreAssets();
        }, this);
        view.signals.resize.add(this.onCanvasResize, this);
        common.view = view;

        this.loadConfig(function () {
            //	view._options.rotateImageUrl = `./assets/images/localisation/rotate_${common.config.language}.jpg`;
            view.init();
        }, this);    // we load the config before we do anything
    }

    loadConfig(callback, scope) {
        scope = scope || window;
        P3.assets.addFiles([{name: 'config', url: 'config' + '.json'}], './');
        P3.assets.signals.complete.once(function () {
            common.config = P3.assets.json('config');
            common.config.language = window.__language;
            //common.langauge =
            callback && callback.call(scope);
        }, this);
        P3.assets.load();
    }

    loadPreAssets() {
        const files = [
            {name: 'strings', url: 'data/strings' + '.json'},
            {name: 'cn_preloader_1x', url: 'images/cn_preloader_1x' + '.json'},
            {name: 'ui_1x', url: 'images/ui_1x' + '.json'},

            {name: 'cn_preloader', url: 'images/cn_preloader' + '.jpg'},
            /*
            {name: 'loading_ar', url: 'images/localisation/loading_ar' + '.png'},

            {name: 'buttons_1x', url: 'images/buttons_1x' + '.json'},
            {name: 'strings', url: 'data/strings' + '.json'},
            {name: 'cn_preloader', url: 'images/cn_preloader' + '.jpg'},
            {name: 'ed_72', url: 'fonts/' + 'ed_72' + '.fnt'},
            {name: 'grilledcheese_56', url: 'fonts/' + 'grilledcheese_56' + '.fnt'},
            {name: 'ed_90_colours', url: 'fonts/' + 'ed_90_colours' + '.fnt'},
            {name: 'cn_preloader_1x', url: 'images/cn_preloader_1x' + '.json'},
            {name: 'ui_1x', url: 'images/ui_1x' + '.json'}

             */
        ];
        if (files.length) {
            P3.assets.addFiles(files, './assets/');
            P3.assets.signals.complete.once(this.loadAssets, this);
            P3.assets.load();
        } else this.loadAssets();
    }

    loadAssets() {
        const files = [

            // character assets
            {name: 'character', url: 'spine/character' + '.json'},
            {name: 'character_pencil', url: 'spine/paths' + '.json'},
            {name: 'character_data', url: 'data/character' + '.json'},

            // bg
            {name: 'bg_game', url: 'images/bg_gameplay_1x' + '.jpg'},

            // SFX
            {name: 'sfx_btn_ui_commit_00', url: 'audio/' + 'sfx_btn_ui_commit_00' + P3.assets.audioFileExt},
            {name: 'sfx_btn_ui_next_drawing_00', url: 'audio/' + 'sfx_btn_ui_next_drawing_00' + P3.assets.audioFileExt},
            {name: 'sfx_btn_ui_prev_drawing_00', url: 'audio/' + 'sfx_btn_ui_prev_drawing_00' + P3.assets.audioFileExt},
            {name: 'sfx_btn_ui_print_00', url: 'audio/' + 'sfx_btn_ui_print_00' + P3.assets.audioFileExt},
            {name: 'sfx_btn_ui_repeatstep_00', url: 'audio/' + 'sfx_btn_ui_repeatstep_00' + P3.assets.audioFileExt},
            {name: 'sfx_btn_ui_trash_00', url: 'audio/' + 'sfx_btn_ui_trash_00' + P3.assets.audioFileExt},
            {name: 'sfx_drawing_fill_00', url: 'audio/' + 'sfx_drawing_fill_00' + P3.assets.audioFileExt},
            {name: 'sfx_drawing_loop_00', url: 'audio/' + 'sfx_drawing_loop_00' + P3.assets.audioFileExt},

            // Music
            {name: 'music_menu_loop_00', url: 'audio/' + 'music_menu_loop_00' + P3.assets.audioFileExt},
            {name: 'music_drawing_loop_00', url: 'audio/' + 'music_drawing_loop_00' + P3.assets.audioFileExt},
            {name: 'music_complete_sting_02', url: 'audio/' + 'music_complete_sting_02' + P3.assets.audioFileExt},
            {name: 'music_complete_sting_01', url: 'audio/' + 'music_complete_sting_01' + P3.assets.audioFileExt},
            {name: 'music_complete_sting_00', url: 'audio/' + 'music_complete_sting_00' + P3.assets.audioFileExt}

        ];
        if (files.length) {
            common.config.strings = P3.assets.json('strings');

            this._preloader = new PreloaderScene();
            P3.scene.show(this._preloader);

            P3.assets.addFiles(files, './assets/');
            P3.assets.signals.progress.add(this.onLoadingProgress, this);
            P3.assets.signals.complete.once(this.onLoadingCompleted, this);
            P3.assets.load();
        } else this.start();
    }

    start() {
        this._app = new Application();
        this._app.init();
    }

    onLoadingProgress(event) {
        this._preloader && (this._preloader.loaded = event.progress / 100);
        //console.log("loading:", event.progress);
    }

    onLoadingCompleted() {
        this._preloader && (this._preloader.loaded = 1);
        //this._preloader.signals.mobileLoad.add(() => {
        this.start();
        //});
    }

    onCanvasResize(correct) {
        if (correct) {
            common.renderer.resize(P3.View.width, P3.View.height);
            if (P3.scene) {
                P3.scene.resize();

                for (let i = 0; i < common.transitions.children.length; ++i) {
                    const transition = common.transitions.children[i];
                    transition.resize && transition.resize();
                }
            }
        }
    }
}
